import { Music } from "lucide-react";

export const Marquee = ({ items, className = "", testid = "marquee" }) => (
  <div className={`overflow-hidden border-y-[3px] border-ink ${className}`} data-testid={testid}>
    <div className="flex w-max animate-marquee whitespace-nowrap">
      {[0, 1].map((dup) => (
        <div key={dup} aria-hidden={dup === 1} className="flex items-center">
          {items.map((it, i) => (
            <span key={i} className="flex items-center px-6 md:px-8">
              <span className="font-display uppercase tracking-tight text-2xl md:text-4xl">{it}</span>
              <Music size={26} className="ml-12 md:ml-16 shrink-0 text-brand-gold" aria-hidden="true" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);

export default Marquee;
